export var EThemes;
(function (EThemes) {
    EThemes["RED"] = "red";
    EThemes["ORANGE"] = "orange";
    EThemes["YELLOW"] = "yellow";
    EThemes["GREEN"] = "green";
    EThemes["AQUAMARINE"] = "aquamarine";
    EThemes["BLUE"] = "blue";
    EThemes["PURPLE"] = "purple";
    EThemes["PINK"] = "pink";
    EThemes["BLACK"] = "black";
})(EThemes || (EThemes = {}));
export const normalizeThemeValuesWithDefaults = (theme) => (Object.assign(Object.assign({}, theme), { colors: Object.assign(Object.assign({ textLighter: theme.colors.text, textAboveBackground: '#FFF', secondaryBackground: theme.colors.secondary }, theme.colors), { illustration: Object.assign({ quinary: theme.colors.illustration.secondary }, theme.colors.illustration), welcome: Object.assign({ backgroundLight: '#FFF', backgroundCarousel: '#FFF' }, theme.colors.welcome) }) }));
export const ThemesDictionary = {
    [EThemes.RED]: {
        name: EThemes.RED,
        colors: {
            primary: '#F44734',
            primary200: '#EB3B47',
            primary400: '#C8969C',
            primary500: '#FBE4E4',
            primary600: '#FBE4E466',
            secondary: '#EB3B47',
            illustration: {
                primary: '#A1272E',
                secondary: '#EB3B47',
                tertiary: '#F2E1E1',
                quaternary: '#D6333E',
                stopColor: '#FDE7E9',
                firstStopColor: '#FDE7E9',
                secondStopColor: '#FDE7E900'
            },
            text: '#DF515B',
            darkText: '#CD7E83',
            link: '#A1272E',
            linkHover: '#851F25',
            slightBorder: '#F8ECEC',
            slightBackground: '#FFFDFD',
            background: '#922E3A',
            backgroundGradient: 'linear-gradient(263.71deg, #EB3B47 5.13%, #D0333D 96.77%)',
            backgroundGradientHover: 'linear-gradient(263.71deg, #DE3B48 5.13%, #B63A42 96.77%)',
            backgroundGradient2Hover: 'linear-gradient(263.71deg, #CF333E 5.13%, #A31B25 96.77%)',
            slightGradient: 'linear-gradient(180deg, rgba(253, 231, 233, 0.7) 0%, rgba(253, 231, 233, 0) 76.15%)',
            shadowColor: 'rgba(235, 59, 71, 0.44)',
            freeCoinsCampaign: {
                background: '#FEF5F6'
            },
            referral: {
                tracking: {
                    background: 'rgba(255, 250, 250, 0.8)',
                    backgroundItem: 'rgba(200, 150, 156, 0.08)'
                }
            },
            typography: '#443637',
            welcome: {
                background: '#691A2B',
                backgroundLight: '#FFFCFD',
                colorLight: '#C0094E',
                dotSlide: '#DBD5D8'
            },
            backgroundCoin: {
                gradientColor1: '#CF333E',
                gradientColor2: '#A31B25'
            }
        }
    },
    [EThemes.ORANGE]: {
        name: EThemes.ORANGE,
        colors: {
            primary: '#FF8A1E',
            primary200: '#FF971E',
            primary400: '#DCB28B',
            primary500: '#F9EADA',
            primary600: '#FFFAF4',
            secondary: '#EC7200',
            illustration: {
                primary: '#C95D0F',
                secondary: '#FF971E',
                tertiary: '#FAE7D2',
                quaternary: '#F38B13',
                stopColor: '#FFE0BC',
                firstStopColor: '#FFE0BC99',
                secondStopColor: '#FFE0BC00'
            },
            text: '#D9915D',
            darkText: '#DDB283',
            link: '#C95D0F',
            linkHover: '#A34C0D',
            slightBorder: '#F9EADA',
            slightBackground: '#FFFEFB',
            background: '#B96517',
            backgroundGradient: 'linear-gradient(263.71deg, #FF981E 5.13%, #EC7100 96.77%)',
            backgroundGradientHover: 'linear-gradient(263.71deg, #F18909 5.13%, #D66F00 96.77%)',
            backgroundGradient2Hover: 'linear-gradient(263.71deg, #EE8100 5.13%, #C05C00 96.77%)',
            slightGradient: 'linear-gradient(180deg, rgba(255, 224, 188, 0.6) 0%, rgba(255, 224, 188, 0) 76.15%)',
            shadowColor: 'rgba(250, 150, 0, 0.42)',
            freeCoinsCampaign: {
                background: '#FFFAF4'
            },
            referral: {
                tracking: {
                    background: 'rgba(255, 250, 244, 0.6)',
                    backgroundItem: 'rgba(220, 178, 139, 0.08)'
                }
            },
            typography: '#473E33',
            welcome: {
                background: '#5C2E03',
                backgroundLight: '#FFFCFA',
                colorLight: '#FF8A00',
                dotSlide: '#E2DCD7'
            },
            backgroundCoin: {
                gradientColor1: '#EE8100',
                gradientColor2: '#C05C00'
            }
        }
    },
    [EThemes.YELLOW]: {
        name: EThemes.YELLOW,
        colors: {
            primary: '#FFD705',
            primary200: '#F4A700',
            primary400: '#E0BC6C',
            primary500: '#F7EFCF',
            primary600: '#F7EFCF80',
            secondary: '#F5A901',
            illustration: {
                primary: '#B27A01',
                secondary: '#FCCD03',
                tertiary: '#F7E9B9',
                quaternary: '#EEBA00',
                quinary: '#6A4C02',
                stopColor: '#FCEA9D',
                firstStopColor: '#FCEA9D66',
                secondStopColor: '#FFEDA200'
            },
            text: '#DA9500',
            darkText: '#CDB96A',
            link: '#B27A01',
            linkHover: '#895E00',
            textLighter: '#10222D80',
            textAboveBackground: '#6A4C02',
            slightBorder: '#F2EFDE',
            slightBackground: '#FFFDFC',
            secondaryBackground: '#3D3D3D',
            background: '#C98B01',
            backgroundGradient: 'linear-gradient(263.71deg, #FCCD03 5.13%, #F4A700 96.77%)',
            backgroundGradientHover: 'linear-gradient(263.71deg, #EBB800 5.13%, #E49607 96.77%)',
            backgroundGradient2Hover: 'linear-gradient(263.71deg, #E9B500 5.13%, #C78800 96.77%)',
            slightGradient: 'linear-gradient(180deg, rgba(252, 234, 157, 0.4) 0%, rgba(255, 237, 162, 0) 76.15%)',
            shadowColor: 'rgba(250, 150, 0, 0.42)',
            freeCoinsCampaign: {
                background: '#FFFDF2'
            },
            referral: {
                tracking: {
                    background: 'rgba(253, 251, 242, 0.8)',
                    backgroundItem: 'rgba(224, 188, 108, 0.08)'
                }
            },
            typography: '#474333',
            welcome: {
                background: '#653F02',
                backgroundLight: '#FFFCF7',
                colorLight: '#FFC33E',
                dotSlide: '#DBD4C8'
            },
            backgroundCoin: {
                gradientColor1: '#E9B500',
                gradientColor2: '#C78800'
            }
        }
    },
    [EThemes.GREEN]: {
        name: EThemes.GREEN,
        colors: {
            primary: '#25A22A',
            primary200: '#19A45A',
            primary400: '#91C3AA',
            primary500: '#D9EEE4',
            primary600: '#D9EEE466',
            secondary: '#19A862',
            illustration: {
                primary: '#137B49',
                secondary: '#24DA6D',
                tertiary: '#B4E2C7',
                quaternary: '#1FC261',
                stopColor: '#D4F8E3',
                firstStopColor: '#D4F8E3',
                secondStopColor: '#D4F8E300'
            },
            text: '#18A561',
            darkText: '#78BA93',
            link: '#137B49',
            linkHover: '#0E5C37',
            slightBorder: '#D9EEE4',
            slightBackground: '#FAFEFC',
            background: '#248756',
            backgroundGradient: 'linear-gradient(263.71deg, #22CF67 5.13%, #18A561 96.77%)',
            backgroundGradientHover: 'linear-gradient(263.71deg, #36BF68 5.13%, #189559 96.77%)',
            backgroundGradient2Hover: 'linear-gradient(263.71deg, #127841 5.13%, #0C502C 96.77%)',
            slightGradient: 'linear-gradient(180deg, #D4F8E3 0%, rgba(212, 248, 227, 0) 76.15%)',
            shadowColor: 'rgba(31, 190, 95, 0.6)',
            freeCoinsCampaign: {
                background: '#F4FDF8'
            },
            referral: {
                tracking: {
                    background: 'rgba(217, 238, 228, 0.2)',
                    backgroundItem: 'rgba(217, 238, 228, 0.4)'
                }
            },
            typography: '#33473B',
            welcome: {
                background: '#044132',
                backgroundLight: '#FCFFFD',
                colorLight: '#05AA81',
                dotSlide: '#C8DBD0'
            },
            backgroundCoin: {
                gradientColor1: '#127841',
                gradientColor2: '#0C502C'
            }
        }
    },
    [EThemes.AQUAMARINE]: {
        name: EThemes.AQUAMARINE,
        colors: {
            primary: '#09B6BC',
            primary200: '#0AB3B8',
            primary400: '#6EB5BA',
            primary500: '#D2EDEF',
            primary600: '#EDF9FA',
            secondary: '#07A7AD',
            illustration: {
                primary: '#067E82',
                secondary: '#10CBD1',
                tertiary: '#C8EAEB',
                quaternary: '#0FB9BE',
                stopColor: '#DEF5F6',
                firstStopColor: '#DEF5F6',
                secondStopColor: '#DEF5F600'
            },
            text: '#06A5AA',
            darkText: '#81BBC0',
            link: '#067E82',
            linkHover: '#05585A',
            slightBorder: '#C8EAEB',
            slightBackground: '#F9FDFD',
            background: '#09828A',
            backgroundGradient: 'linear-gradient(263.71deg, #10CBD1 5.13%, #06A5AA 96.77%)',
            backgroundGradientHover: 'linear-gradient(263.71deg, #0EAEB4 5.13%, #07989D 96.77%)',
            backgroundGradient2Hover: 'linear-gradient(263.71deg, #088D91 5.13%, #056366 96.77%)',
            slightGradient: 'linear-gradient(180deg, #DEF5F6 0%, rgba(222, 245, 246, 0) 76.15%)',
            shadowColor: 'rgba(10, 177, 183, 0.5)',
            freeCoinsCampaign: {
                background: '#F3FCFD'
            },
            referral: {
                tracking: {
                    background: 'rgba(237, 249, 250, 0.5)',
                    backgroundItem: 'rgba(110, 181, 186, 0.08)'
                }
            },
            typography: '#2A4647',
            welcome: {
                background: '#034345',
                backgroundLight: '#FAFFFF',
                colorLight: '#0ABFC5',
                dotSlide: '#C6D8D8'
            },
            backgroundCoin: {
                gradientColor1: '#088D91',
                gradientColor2: '#056366'
            }
        }
    },
    [EThemes.BLUE]: {
        name: EThemes.BLUE,
        colors: {
            primary: '#329DFC',
            primary200: '#1E95FF',
            primary400: '#80B0DC',
            primary500: '#BDE0FF',
            primary600: '#EBF5FF',
            secondary: '#168EF9',
            illustration: {
                primary: '#0075E2',
                secondary: '#1E95FF',
                tertiary: '#D2E5F9',
                quaternary: '#0282F4',
                stopColor: '#E1F1FF',
                firstStopColor: '#E1F1FF',
                secondStopColor: '#D2EAFF00'
            },
            text: '#329DFC',
            darkText: '#5C94CD',
            link: '#1E95FF',
            linkHover: '#0672D2',
            slightBorder: '#E7F3FF',
            slightBackground: '#EFF7FF',
            background: '#0162B9',
            backgroundGradient: 'linear-gradient(263.71deg, #1E95FF 5.13%, #007CEA 96.77%)',
            backgroundGradientHover: 'linear-gradient(263.71deg, #0081F5 5.13%, #0571D1 96.77%)',
            backgroundGradient2Hover: 'linear-gradient(263.71deg, #1085ED 5.13%, #0068C5 96.77%)',
            slightGradient: 'linear-gradient(180deg, #E1F1FF -22.71%, rgba(210, 234, 255, 0) 76.15%)',
            shadowColor: 'rgba(0, 107, 232, 0.52)',
            freeCoinsCampaign: {
                background: '#F4FAFF'
            },
            referral: {
                tracking: {
                    background: 'rgba(235, 245, 255, 0.36)',
                    backgroundItem: '#EDF4FD'
                }
            },
            typography: '#012A5A',
            welcome: {
                background: '#0B3874',
                backgroundLight: '#F7F9FF',
                colorLight: '#036FFF',
                dotSlide: '#CDDAEB'
            },
            backgroundCoin: {
                gradientColor1: '#1085ED',
                gradientColor2: '#0068C5'
            }
        }
    },
    [EThemes.PURPLE]: {
        name: EThemes.PURPLE,
        colors: {
            primary: '#C41EFF',
            primary200: '#A532FF',
            primary400: '#A87BCB',
            primary500: '#E7E0FF',
            primary600: '#F7F5FF',
            secondary: '#8812E5',
            illustration: {
                primary: '#6408AC',
                secondary: '#A532FF',
                tertiary: '#EFE4FF',
                quaternary: '#9726EF',
                stopColor: '#8032FF',
                firstStopColor: '#8032FF33',
                secondStopColor: '#8032FF00'
            },
            text: '#850FE2',
            darkText: '#BBA1E7',
            link: '#6408AC',
            linkHover: '#450577',
            slightBorder: '#E9E5F5',
            slightBackground: '#FBFAFF',
            background: '#6516A3',
            backgroundGradient: 'linear-gradient(263.71deg, #A532FF 5.13%, #850FE2 96.77%)',
            backgroundGradientHover: 'linear-gradient(263.71deg, #8F00FF 5.13%, #710DBF 96.77%)',
            backgroundGradient2Hover: 'linear-gradient(263.71deg, #8A1AE2 5.13%, #6304AE 96.77%)',
            slightGradient: 'linear-gradient(180deg, rgba(154, 92, 255, 0.2) 0%, rgba(154, 92, 255, 0) 76.15%)',
            shadowColor: 'rgba(70, 15, 226, 0.4)',
            freeCoinsCampaign: {
                background: '#FAF5FF'
            },
            referral: {
                tracking: {
                    background: 'rgba(247, 245, 255, 0.6)',
                    backgroundItem: 'rgba(168, 123, 203, 0.1)'
                }
            },
            typography: '#3A2B46',
            welcome: {
                background: '#3B0763',
                backgroundLight: '#FDFAFF',
                colorLight: '#8C1EE2',
                dotSlide: '#E4C9DA'
            },
            backgroundCoin: {
                gradientColor1: '#8A1AE2',
                gradientColor2: '#6304AE'
            }
        }
    },
    [EThemes.PINK]: {
        name: EThemes.PINK,
        colors: {
            primary: '#FA05B9',
            primary200: '#FA05A7',
            primary400: '#D588B7',
            primary500: '#FBE6F2',
            primary600: '#FBE6F266',
            secondary: '#DE0186',
            illustration: {
                primary: '#9C0067',
                secondary: '#FA05A7',
                tertiary: '#F6DCEC',
                quaternary: '#EE009D',
                stopColor: '#FA0598',
                firstStopColor: '#FA059833',
                secondStopColor: '#FA059800'
            },
            text: '#DC0084',
            darkText: '#D38AAF',
            link: '#9C0067',
            linkHover: '#71024B',
            slightBorder: '#FBE6F2',
            slightBackground: '#FBE6F2',
            background: '#AC126F',
            backgroundGradient: 'linear-gradient(263.71deg, #FA05A7 5.13%, #DC0084 96.77%)',
            backgroundGradientHover: 'linear-gradient(263.71deg, #E10596 5.13%, #C60679 96.77%)',
            backgroundGradient2Hover: 'linear-gradient(263.71deg, #D9008F 5.13%, #B5006C 96.77%)',
            slightGradient: 'linear-gradient(180deg, rgba(250, 5, 152, 0.14) 0%, rgba(250, 5, 152, 0) 76.15%)',
            shadowColor: 'rgba(250, 5, 166, 0.52)',
            freeCoinsCampaign: {
                background: '#FFF3FB'
            },
            referral: {
                tracking: {
                    background: '#FFFBFD',
                    backgroundItem: 'rgba(213, 136, 183, 0.1)'
                }
            },
            typography: '#483241',
            welcome: {
                background: '#680045',
                backgroundLight: '#FFFAFD',
                colorLight: '#E30096',
                dotSlide: '#E4C9DA'
            },
            backgroundCoin: {
                gradientColor1: '#D9008F',
                gradientColor2: '#B5006C'
            }
        }
    },
    [EThemes.BLACK]: {
        name: EThemes.BLACK,
        colors: {
            primary: '#343434',
            primary200: '#515560',
            primary400: '#A9ADB7',
            primary500: '#DAE1EC',
            primary600: '#DAE1EC66',
            secondary: '#384357',
            illustration: {
                primary: '#191D25',
                secondary: '#4C505B',
                tertiary: '#DCE1E5',
                quaternary: '#3A3E45',
                stopColor: '#4B5C70',
                firstStopColor: '#4B5C7033',
                secondStopColor: '#4B5C7000'
            },
            text: '#949DB6',
            darkText: '#949DB6',
            link: '#384357',
            linkHover: '#0E1116',
            slightBorder: '#DCE2E8',
            slightBackground: '#FCFDFD',
            background: '#454852',
            backgroundGradient: 'linear-gradient(263.71deg, #4A4E56 5.13%, #2A2D35 96.77%)',
            backgroundGradientHover: 'linear-gradient(263.71deg, #3D4047 5.13%, #1D1F25 96.77%)',
            backgroundGradient2Hover: 'linear-gradient(263.71deg, #34363D 5.13%, #0A0B0F 96.77%)',
            slightGradient: 'linear-gradient(180deg, rgba(75, 92, 112, 0.2) 0%, rgba(75, 92, 112, 0) 76.15%)',
            shadowColor: 'rgba(66, 75, 92, 0.62)',
            freeCoinsCampaign: {
                background: '#F6F6F7'
            },
            referral: {
                tracking: {
                    background: '#FAFAFA',
                    backgroundItem: 'rgba(169, 173, 183, 0.1)'
                }
            },
            typography: '#384357',
            welcome: {
                background: '#24262D',
                colorLight: '#767A89',
                backgroundLight: '#555964',
                backgroundCarousel: '#333640',
                dotSlide: '#383B43'
            },
            backgroundCoin: {
                gradientColor1: '#4A4E56',
                gradientColor2: '#2A2D35'
            }
        }
    }
};
export const initTheme = (color) => {
    const rawTheme = ThemesDictionary[color];
    const theme = normalizeThemeValuesWithDefaults(rawTheme);
    initCSSVars(theme);
    return theme;
};
const initCSSVars = (theme) => {
    const prefix = 'twism-theme';
    const setCSSVars = (obj, objName) => {
        for (const prop in obj) {
            const item = obj[prop];
            if (typeof item === 'string') {
                document.documentElement.style.setProperty(`--${prefix}-${objName ? `${objName}-` : ''}${prop}`, item);
            }
            else {
                setCSSVars(item, prop);
            }
        }
    };
    setCSSVars(theme.colors);
    document.documentElement.style.setProperty(`--${prefix}-name`, theme.name);
};
